const SparkleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_1804_745)">
        <path
          d="M12.7207 11.7798L14.667 12.5005L12.7207 13.2202L12.001 15.1665L11.2803 13.2202L9.33398 12.5005L11.2803 11.7798L12.001 9.8335L12.7207 11.7798ZM8.53125 6.63623L12.667 8.1665L8.53125 9.69775L7.00098 13.8335L5.46973 9.69775L1.33398 8.1665L5.46973 6.63623L7.00098 2.50049L8.53125 6.63623ZM13.208 3.29346L14.668 3.8335L13.208 4.37354L12.668 5.8335L12.127 4.37354L10.668 3.8335L12.127 3.29346L12.668 1.8335L13.208 3.29346Z"
          fill="#001018"
        />
      </g>
      <defs>
        <clipPath id="clip0_1804_745">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SparkleIcon
